import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    CmpsAccordionModule,
    CmpsCheckboxModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CaEvaluationComponent } from './ca-evaluation.component';
import { FocusActionsComponent } from './component/focus-actions/focus-actions.component';
import { FocusComponent } from './component/focus/focus.component';
import { NewMyFocusComponent } from './component/new-my-focus/new-my-focus.component';
import { NewMyPhaseComponent } from './component/new-my-phrase/new-my-phase.component';
import { PhaseActionsComponent } from './component/phase-actions/phase-actions.component';
import { PhaseContentComponent } from './component/phase-content/phase-content.component';
import { PhaseHeaderComponent } from './component/phase-header/phase-header.component';
import { PhraseComponent } from './component/phrase/phrase.component';

@NgModule({
    declarations: [
        CaEvaluationComponent,
        FocusActionsComponent,
        FocusComponent,
        NewMyFocusComponent,
        NewMyPhaseComponent,
        PhaseActionsComponent,
        PhaseContentComponent,
        PhaseHeaderComponent,
        PhraseComponent,
    ],
    exports: [CaEvaluationComponent],
    imports: [
        CmpsAccordionModule,
        CmpsCheckboxModule,
        CmpsIconModule,
        CmpsTooltipModule,
        CommonModule,
        FormsModule,
    ],
})
export class CmpsCaEvaluationModule {}
